import React from "react";
import { BaseFilterProps } from "../../lib";
import { OrgTaskTemplateOptionsFilter } from "./OrgTaskTemplateOptionsFilter";
import {
    isAssigneeRoleValue,
    ORG_TASK_TEMPLATE_ROLE_OPTIONS,
} from "./orgTaskTemplateFilterOptions";

export const OrgTaskTemplateAssigneeRoleFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => (
    <OrgTaskTemplateOptionsFilter
        options={ORG_TASK_TEMPLATE_ROLE_OPTIONS}
        selected={filters.orgTaskTemplateAssigneeRoles}
        isOptionValue={isAssigneeRoleValue}
        onChange={(orgTaskTemplateAssigneeRoles) =>
            onChange({ orgTaskTemplateAssigneeRoles })
        }
        name="orgTaskTemplateAssigneeRoles"
        searchable={false}
    />
);
